import Modal from "kustom-front/src/components/molecules/Modal";
import sortBy from "lodash/sortBy";
import React, { FunctionComponent } from "react";
import { FormattedMessage } from "react-intl";
import useCartContext from "@Hooks/useCartContext";
import Promo from "@Types/promos";
import Gift from "./gift.gif";
import PromoItem from "./PromoItem";
import "./style.scss";

interface Props extends ContainerProps {
  promos: Promo[];
}

interface ContainerProps {
  display: boolean;
  onDismiss: () => void;
  onSelectPromo: (promoValue: string) => void;
}

export const PromosModal: FunctionComponent<Props> = ({
  display,
  onDismiss,
  onSelectPromo,
  promos,
}) => {
  const sortedPromos = sortBy(promos, (a) => -a.priority);

  return (
    <Modal display={display} onDismiss={onDismiss} showCloseButton={true}>
      <div className="PromosModal">
        <div className="PromosModal-header-wrapper">
          <div className="PromosModal-header" />
          <img className="PromosModal-header-image" src={Gift} />
          <div className="PromosModal-header-label">
            <FormattedMessage id="cheerz_PromosModal_label" />
          </div>
        </div>
        <div className="PromosModal-promos">
          {sortedPromos.map((promo: Promo) => {
            return (
              <PromoItem
                code={promo.code}
                description={promo.description}
                key={promo.code}
                onSelectPromo={() => onSelectPromo(promo.code)}
                title={promo.title}
              />
            );
          })}
        </div>
      </div>
    </Modal>
  );
};

const PromosModalContainer: FunctionComponent<ContainerProps> = ({
  display,
  onDismiss,
  onSelectPromo,
}) => {
  const { promos } = useCartContext();

  return (
    <PromosModal
      display={display}
      onDismiss={onDismiss}
      onSelectPromo={onSelectPromo}
      promos={promos}
    />
  );
};

export default PromosModalContainer;
